import { IconProps } from "@/data/types"

export default function FixIcon({
  width = 32,
  height = 32,
  color = "#000000",
  className,
}: IconProps) {
  return (
    <div className={className}>
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill={color}
        stroke={color}
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          <path
            d="M28,27c0,0.552-0.448,1-1,1s-1-0.448-1-1s0.448-1,1-1S28,26.448,28,27z M29.5,29.5
              c-0.69,0.69-1.595,1.036-2.5,1.036s-1.81-0.345-2.5-1.036L11.563,16.563C10.758,16.84,9.899,17,9,17c-4.411,0-8-3.589-8-8
              c0-0.662,0.089-1.341,0.266-2.018c0.09-0.347,0.359-0.619,0.706-0.713c0.087-0.024,0.175-0.035,0.262-0.035
              c0.262,0,0.517,0.103,0.707,0.293l2.645,2.645C5.964,9.549,6.466,9.757,7,9.757s1.036-0.208,1.414-0.586l0.757-0.757
              C9.549,8.036,9.757,7.534,9.757,7c0-0.534-0.208-1.036-0.586-1.414L6.527,2.941C6.273,2.687,6.175,2.317,6.269,1.971
              c0.094-0.346,0.366-0.615,0.713-0.706C7.659,1.089,8.338,1,9,1c4.411,0,8,3.589,8,8c0,0.899-0.16,1.758-0.437,2.563L29.5,24.5
              C30.881,25.881,30.881,28.119,29.5,29.5z M28.793,25.207L15.405,11.819C15.785,10.956,16,10.004,16,9c0-3.866-3.134-7-7-7
              C8.389,2,7.799,2.086,7.234,2.234l2.645,2.645c1.172,1.172,1.172,3.071,0,4.243L9.121,9.879C8.536,10.464,7.768,10.757,7,10.757
              s-1.536-0.293-2.121-0.879L2.234,7.234C2.086,7.799,2,8.389,2,9c0,3.866,3.134,7,7,7c1.004,0,1.956-0.215,2.819-0.595l13.388,13.388
              c0.479,0.479,1.116,0.743,1.793,0.743c0.677,0,1.314-0.264,1.793-0.743C29.781,27.804,29.781,26.196,28.793,25.207z"
          />
        </g>
      </svg>
    </div>
  )
}
